export default __webpack_public_path__ + "static/media/gallery_09.16fccd92.jpg";